import {
    AnimationBaseController,
    FullScreenManager,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import {
    ButtonController,
    IButtonControllerOptions,
} from '../../Common/ButtonController';
import { GameLogic } from '../../Logic/GameLogic';

import isMobile from 'is-mobile';
import { GameModel } from '../../Models/GameModel';
import { UIMuteController } from './UIMuteButton';

export class UIButtonTopController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic,
        @Inject private _fullScreenManager: FullScreenManager
    ) {
        super('UIButtonTopController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            childControllers: {
                buttonPause: {
                    instanceName: 'button_info',
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.showInfoScreen();
                        },
                    },
                },
                buttonMap: {
                    instanceName: 'button_map',
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.showGameMiniMap();
                        },
                    },
                },
                buttonMute: {
                    instanceName: 'btn_mute',
                    controller: UIMuteController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.mute(!this.$model.muteState);
                            this.soundManager.setMasterVolume(this.$model.muteState ? 0 : 1);
                        },
                    },
                },
            },
        };
    }

    protected onInitialize(): void {}

    protected onResize(width: number, height: number, scale: number): void {
        this.x = width / scale / 2;
        this.y = height / scale / 2 + (isMobile() ? 0 : -250);
    }
}
